import React, { useCallback } from "react";
import { AspectRatio, Box, Image, Text } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { useFormatDateTime } from "@bookingcom/flights-core";
import { SPACER_PADDED } from "@flights/constants";
import { getRoundtripSearchUrl } from "../../../utils/search-urls.js";
import styles from "./PopularFlightsItem.module.css";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import useLandingPageEvents from "../../../hooks/c360/useLandingPageEvents.js";
import { useLocation } from "react-router-dom";
const getSearchUrl = (flight, prevSearchParams) => {
    return getRoundtripSearchUrl({
        fromIata: flight.fromCityIata,
        toIata: flight.toCityIata,
        departureDate: flight.tripStartDate,
        returnDate: flight.tripEndDate
    }, "flights_index_pf", prevSearchParams);
};
const FlightsNearbyItem = ({ flight, index, component }) => {
    const i18n = useI18n();
    const { formats } = useFormatDateTime(i18n);
    const { createUrlWithApiPrefix } = useCreateUrl();
    const trackLandingPageEvents = useLandingPageEvents();
    const location = useLocation();
    const routeName = i18n.trans(t("seo_flights_new_index_lp_cheap_flights_meta_flight_route", {
        variables: { city_name_origin: flight.fromCityNameLocalised, city_name_destination: flight.toCityNameLocalised }
    }));
    const fromDateFormatted = formats.flightDate(flight.tripStartDate);
    const toDateFormatted = formats.flightDate(flight.tripEndDate);
    const flightParams = `${fromDateFormatted} - ${toDateFormatted}` +
        SPACER_PADDED +
        `${i18n.trans(t("seo_flights_new_index_lp_cheap_flights_meta_round_trip"))}`;
    const url = createUrlWithApiPrefix(getSearchUrl(flight, location?.search));
    const handleClick = useCallback(() => {
        trackLandingPageEvents("click", component, { ...flight, position: index + 1, url });
    }, [trackLandingPageEvents, component, flight, index, url]);
    const imageUrl = flight.toCityImageUrl;
    return (React.createElement("a", { className: styles.anchorContainer, href: url, rel: "nofollow", onClick: handleClick, onAuxClick: handleClick },
        React.createElement(Box, { padding: 0 },
            React.createElement(AspectRatio, { ratio: "4:3" },
                React.createElement(Image, { className: styles.image, src: imageUrl, alt: "", fallback: "icon" })),
            React.createElement("div", { className: styles.textContainer },
                React.createElement(Text, { className: styles.textLine, variant: "strong_1" }, routeName),
                React.createElement(Text, { className: styles.textLine, variant: "body_2", color: "neutral_alt" }, flightParams)))));
};
export default FlightsNearbyItem;
